import { render } from "./Workbook.vue?vue&type=template&id=f94e36ac&scoped=true"
import script from "./Workbook.vue?vue&type=script&lang=js"
export * from "./Workbook.vue?vue&type=script&lang=js"

import "./Workbook.vue?vue&type=style&index=0&id=f94e36ac&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94e36ac"],['__file',"src/components/Workbook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f94e36ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f94e36ac', __exports__)) {
    console.log('reload')
    api.reload('f94e36ac', __exports__)
  }
  
  module.hot.accept("./Workbook.vue?vue&type=template&id=f94e36ac&scoped=true", () => {
    console.log('re-render')
    api.rerender('f94e36ac', render)
  })

}


export default __exports__